"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALID_USER_TOKEN = exports.CREATE_NEW_ONE_OFF_CHECKOUT_SESSION = exports.CREATE_NEW_SUBSCRIPTION_CHECKOUT_SESSION = void 0;
const client_1 = require("@apollo/client");
exports.CREATE_NEW_SUBSCRIPTION_CHECKOUT_SESSION = (0, client_1.gql) `
  mutation CreateNewSubscriptionCheckoutSession(
    $priceId: String!
    $additionalPriceId: String
  ) {
    validUserToken {
      createNewSubscriptionCheckoutSession(
        priceId: $priceId
        additionalPriceId: $additionalPriceId
      )
    }
  }
`;
exports.CREATE_NEW_ONE_OFF_CHECKOUT_SESSION = (0, client_1.gql) `
  mutation CreateNewOneOffCheckoutSession(
    $priceId: String!
    $additionalPriceId: String
  ) {
    validUserToken {
      createNewOneOffCheckoutSession(
        priceId: $priceId
        additionalPriceId: $additionalPriceId
      )
    }
  }
`;
exports.VALID_USER_TOKEN = (0, client_1.gql) `
  mutation ValidUserToken {
    validUserToken {
      renewToken
    }
  }
`;
